import React, { useRef, useEffect } from "react"
import { Box } from "theme-ui"
import { FiChevronsRight } from "@react-icons/all-files/fi/FiChevronsRight"
import { FiChevronsLeft } from "@react-icons/all-files/fi/FiChevronsLeft"
import { Navigation, Pagination } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "assets/css/custom-swiper.css"
import styled from "@emotion/styled"

const Wrapper = styled.div`
    max-height: 100vh;
`

const Slideshow = ({ data, initialSlide }) => {
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiper = useRef(null)
    const setSwiper = (newSwiper) => {
        swiper.current = newSwiper
    }

    useEffect(() => {
        if (swiper.current) {
            swiper.current.slideTo(initialSlide)
        }
    }, [initialSlide])

    return (
        <Wrapper>
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    pt: 4,
                    py: 3,
                }}
            >
                <Swiper
                    modules={[Pagination, Navigation]}
                    centeredSlides={true}
                    slidesPerView={1}
                    navigation={true}
                    pagination={{ clickable: true }}
                    initialSlide={initialSlide}
                    onInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current
                        swiper.params.navigation.nextEl = nextRef.current
                        swiper.navigation.init()
                        swiper.navigation.update()
                    }}
                    onSwiper={setSwiper}
                    className="slideshow"
                >
                    {data.map((obj, index) => {
                        return (
                            <SwiperSlide key={index} virtualIndex={index}>
                                <img
                                    src={obj.media.publicURL}
                                    width="600"
                                    alt={obj.alternativeText}
                                />
                                <Box sx={{ mb: 3 }}>{obj.title}</Box>
                            </SwiperSlide>
                        )
                    })}
                    <div className="swiper-button-prev" ref={prevRef}>
                        <FiChevronsLeft />
                    </div>
                    <div className="swiper-button-next" ref={nextRef}>
                        <FiChevronsRight />
                    </div>
                </Swiper>
            </Box>
        </Wrapper>
    )
}

export default Slideshow
